import { gql } from '@apollo/client';
import {
  BASE_QUESTIONNAIRE_COMPANY_RESPONSE_FRAGMENT,
  BASE_QUESTIONNAIRE_FRAGMENT,
  QUESTIONNAIRE_COMPANY_RESPONSE_FRAGMENT,
  QUESTIONNAIRE_FRAGMENT,
  QUESTIONNAIRE_TEMPLATE_FRAGMENT,
} from 'graphql/secure/fragments/questionnaire.fragments';
import { PARTNER_REQUEST_FRAGMENT } from '../fragments/partner.fragments';

export const GET_QUESTIONNAIRE_TEMPLATES = gql`
  query GetQuestionnaireTemplates {
    questionnaireTemplates {
      edges {
        node {
          ...questionnaireTemplateValues
        }
      }
    }
  }
  ${QUESTIONNAIRE_TEMPLATE_FRAGMENT}
`;

export const GET_QUESTIONNAIRES = gql`
  query GetQuestionnaires($first: Int, $after: String) {
    questionnaires(first: $first, after: $after) {
      count
      edges {
        node {
          ...baseQuestionnaireValues
          requestReceived {
            ...partnerRequestValues
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${BASE_QUESTIONNAIRE_FRAGMENT}
  ${PARTNER_REQUEST_FRAGMENT}
`;

export const GET_QUESTIONNAIRE = gql`
  query GetQuestionnaireOverview($id: UUID!) {
    questionnaire(versionId: $id) {
      ...questionnaireValues
    }
  }
  ${QUESTIONNAIRE_FRAGMENT}
`;

export const GET_QUESTIONNAIRE_OVERVIEW = gql`
  query GetQuestionnaireOverview($id: UUID!) {
    questionnaire(versionId: $id) {
      ...questionnaireValues
    }
    questionnaireCompanyResponses(questionnaireId: $id) {
      summary {
        totalAnswers
        pendingAnswers
        lowRiskAnswers
        mediumRiskAnswers
        highRiskAnswers
      }
    }
  }
  ${QUESTIONNAIRE_FRAGMENT}
`;

export const GET_QUESTIONNAIRE_COMPANY_RESPONSE = gql`
  query GetQuestionnaireCompanyResponse($id: UUID!) {
    questionnaireCompanyResponse(id: $id) {
      ...questionnaireCompanyResponseValues
    }
  }
  ${QUESTIONNAIRE_COMPANY_RESPONSE_FRAGMENT}
`;

export const GET_QUESTIONNAIRE_COMPANY_RESPONSE_OVERVIEW = gql`
  query GetQuestionnaireCompanyResponseOverview(
    $questionnaireId: UUID!
    $questionnaireResponseId: UUID!
  ) {
    questionnaireCompanyResponse(id: $questionnaireResponseId) {
      ...questionnaireCompanyResponseValues
    }
    questionnaire(versionId: $questionnaireId) {
      ...baseQuestionnaireValues
    }
  }
  ${QUESTIONNAIRE_COMPANY_RESPONSE_FRAGMENT}
  ${BASE_QUESTIONNAIRE_FRAGMENT}
`;

export const GET_QUESTIONNAIRE_COMPANY_RESPONSES = gql`
  query GetQuestionnaireCompanyResponses(
    $questionnaireId: UUID!
    $first: Int
    $after: String
    $filters: QuestionnaireResponsesFilters
    $orderBy: QuestionnaireResponsesOrderBy
  ) {
    questionnaireCompanyResponses(
      questionnaireId: $questionnaireId
      first: $first
      after: $after
      filters: $filters
      orderBy: $orderBy
    ) {
      count
      edges {
        node {
          ...baseQuestionnaireCompanyResponseValues
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${BASE_QUESTIONNAIRE_COMPANY_RESPONSE_FRAGMENT}
`;
